import { useCallback } from 'react';
import { useWatermarkStore } from '../store/watermarkStore';

/**
 * 拉取当前用户的页面水印信息。
 *
 * 与 useFetchResourceCodes / useFetchDataPortal 同形态：实际逻辑在 store 里，
 * 这里只提供 hook 入口，方便在 App 的首屏加载与 10 分钟定时刷新里一起调用。
 * 定时刷新顺带解决了规范要求的「跨零点挂机页面需在下次刷新时更新日期」。
 */
export function useFetchWatermark() {
    const refresh = useWatermarkStore((s) => s.refresh);
    const fetchWatermark = useCallback(() => refresh(), [refresh]);
    return { fetchWatermark };
}
